export const validateName = (name: string) => {
	const regex = /^[a-zA-Z]+$/i;
	return !(!name || regex.test(name) === false);
};
